import styled from 'styled-components';

interface IProps {
  children: string;
  htmlFor: string;
  required?: boolean;
}

const FormLabel: React.FC<IProps> = ({ children, htmlFor, required }) => {
  return (
    <div className="ant-col ant-form-item-label">
      <Label htmlFor={htmlFor} required={required}>
        {children}
      </Label>
    </div>
  );
};

const Label = styled.label<{ required?: boolean }>`
  ${({ required }) =>
    required &&
    `	&:before {
		display: inline-block;
		margin-inline-end: 4px;
		color: #ff4d4f;
		font-size: 14px;
		font-family: SimSun, sans-serif;
		line-height: 1;
		content: '*';
	}`}
`;

export default FormLabel;
